
import React from "react";
import { TrackingField } from "./TrackingField";
import { TrackingToggle } from "./TrackingToggle";

interface GoogleAdsSectionProps {
  googleAdsId: string;
  setGoogleAdsId: (value: string) => void;
  googleAdsConversionId: string;
  setGoogleAdsConversionId: (value: string) => void;
  googleAdsApiKey: string;
  setGoogleAdsApiKey: (value: string) => void;
  isEditing: boolean;
  isEnabled?: boolean;
  setIsEnabled?: (value: boolean) => void;
  isApiEnabled?: boolean;
  setIsApiEnabled?: (value: boolean) => void;
}

export const GoogleAdsSection: React.FC<GoogleAdsSectionProps> = ({
  googleAdsId,
  setGoogleAdsId,
  googleAdsConversionId,
  setGoogleAdsConversionId,
  googleAdsApiKey,
  setGoogleAdsApiKey,
  isEditing,
  isEnabled = true,
  setIsEnabled = () => {},
  isApiEnabled = true,
  setIsApiEnabled = () => {},
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">Google Ads</h3>
        
        {isEditing && (
          <div className="flex space-x-4">
            <TrackingToggle
              id="google-ads-enabled"
              label="Activer Google Ads"
              checked={isEnabled}
              onChange={setIsEnabled}
            />
            <TrackingToggle
              id="google-ads-api-enabled"
              label="Activer l'API Google Ads"
              checked={isApiEnabled}
              onChange={setIsApiEnabled}
              disabled={!isEnabled}
            />
          </div>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <TrackingField
          id="google-ads-id"
          label="Google Ads ID"
          value={googleAdsId}
          onChange={setGoogleAdsId}
          isEditing={isEditing}
          placeholder="Exemple: AW-XXXXXXXXXX"
          disabled={!isEnabled && isEditing}
        />
        <TrackingField
          id="google-ads-conversion-id"
          label="Conversion ID"
          value={googleAdsConversionId}
          onChange={setGoogleAdsConversionId}
          isEditing={isEditing}
          placeholder="ID de conversion"
          disabled={!isEnabled && isEditing}
        />
        <TrackingField
          id="google-ads-api-key"
          label="API Key"
          value={googleAdsApiKey}
          onChange={setGoogleAdsApiKey}
          isEditing={isEditing}
          isPassword={true}
          placeholder="Votre clé API Google Ads"
          disabled={(!isEnabled || !isApiEnabled) && isEditing}
        />
      </div>
    </div>
  );
};
